/**
 * DisplayItem > Ref object.
 *
 * @typedef {Object} Ref
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} displayStrategyRef Ref type corresponding to displayStrategy (eg. display.stream.show).
 * @property {String} contentTypeRef Ref type for asset (eg. content.stream.media)
 * @property {String} externalServiceRef Ref type for correponsing social network (eg. external.service.instagram)
 */
class Ref {

	constructor(displayStrategyRef, contentTypeRef, externalServiceRef) {

		this.displayStrategyRef	= displayStrategyRef;
		this.contentTypeRef		= contentTypeRef;
		this.externalServiceRef	= externalServiceRef;
	}
}

export default Ref;